import { ProductReviewsPage } from "components";

const ReviewsPage = () => {
  return <ProductReviewsPage />;
};

export default ReviewsPage;
